import type { AdjustmentFormValues } from '../model'

export const ADJUSTMENT_TYPE_GROUPS = [
  {
    label: 'Frequently used adjustment types',
    types: [
      { code: 'FB', label: 'Forward balance' },
      { code: 'WO', label: 'Overpayment recovery' },
      { code: 'CS', label: 'Adjustment' },
    ],
  },
  {
    label: 'Less commonly used',
    types: [
      { code: '72', label: 'Authorized return' },
      { code: 'L6', label: 'Interest owed' },
      { code: 'IR', label: 'Internal revenue service withholding' },
      { code: 'U1', label: 'Non-reimbursable' },
      { code: 'E3', label: 'Affiliated withholding' },
      { code: 'C5', label: 'Manual invoices' },
    ],
  },
] as const

export const EMPTY_ADJUSTMENT: AdjustmentFormValues = {
  key: null,
  code: '',
  amount: null,
  deductFromTotalPaid: false,
  trackingNumber: '',
  notes: '',
}

export function getAdjustmentTypeLabel(code: string): string {
  for (const group of ADJUSTMENT_TYPE_GROUPS) {
    const found = group.types.find((t) => t.code === code)
    if (found) return found.label
  }
  return code
}

export function isAdjustmentValid(adj: AdjustmentFormValues): boolean {
  return adj.code !== '' && adj.amount !== null && adj.amount !== 0
}
